export default "__VITE_ASSET__nYlmsEba__"